import { BaseDto } from './base.dto';
import { ModifierDto } from './modifier.dto';

export class OrderItemModifierDto extends BaseDto {
  orderItemId: number;
  modifierId: number;
  modifierPrice: number;
  modifierGroupId?: number;
  modifiedDateTime: Date;
  modifier?: ModifierDto;
  selectedForLoyalty?: boolean;
  clickedSequence?: number;
}
